export const SHOW_SIDE_BAR: any = { action: "sidebar", value: true };

export const HIDE_SIDE_BAR: any = { action: "sidebar", value: false };

export const IS_MODULE_LOCK: any = { action: "lock", value: false };

export const SHOW_SIDE_BAR_BUTTON: any = { action: "sidebar-button", value: true };

export const HIDE_SIDE_BAR_BUTTON: any = { action: "sidebar-button", value: false };

export const PROJECT_MODULE_ADDED: any = { action: "project-module-added", value: false,filterText:'project-backgrounds' };



// WEBPACK FOOTER //
// ./src/app/const/all-type-broadcaster-action.const.ts